<template>
  <LegalDocView type="returns" :title="$t('shop.return_policy', 'Rückgabe')">
    <!-- Built-in fallback, shown when no returns text is maintained in the
         admin. Texts under legal.returns.*. -->
    <section>
      <h2 class="font-heading text-xl font-bold text-white mb-3">{{ $t('legal.returns.h_personalized') }}</h2>
      <i18n-t keypath="legal.returns.personalized" tag="p" scope="global">
        <template #withdrawal><NuxtLink :to="localePath('/widerrufsrecht')" class="text-primary hover:underline">{{ $t('shop.withdrawal_policy') }}</NuxtLink></template>
      </i18n-t>
    </section>

    <section>
      <h3 class="font-heading text-lg font-bold text-white mb-2">{{ $t('legal.returns.h_damaged') }}</h3>
      <i18n-t keypath="legal.returns.damaged" tag="p" scope="global">
        <template #imprint><NuxtLink :to="localePath('/imprint')" class="text-primary hover:underline">{{ $t('imprint.title') }}</NuxtLink></template>
      </i18n-t>
    </section>

    <section>
      <h3 class="font-heading text-lg font-bold text-white mb-2">{{ $t('legal.returns.h_cancel') }}</h3>
      <i18n-t keypath="legal.returns.cancel" tag="p" scope="global">
        <template #orders><NuxtLink :to="localePath('/orders')" class="text-primary hover:underline">{{ $t('shop.my_orders') }}</NuxtLink></template>
      </i18n-t>
    </section>

    <section>
      <h3 class="font-heading text-lg font-bold text-white mb-2">{{ $t('legal.returns.h_refunds') }}</h3>
      <p>{{ $t('legal.returns.refunds') }}</p>
    </section>
  </LegalDocView>
</template>

<script setup>
import LegalDocView from '~/components/Legal/LegalDocView.vue'

definePageMeta({ layout: 'shop' })
const { t } = useI18n()
const localePath = useLocalePath()
useSeoMeta({
  title: () => t('shop.return_policy'),
  description: () => t('legal.returns.meta_desc')
})
</script>
